import { createAbTest } from '~/lib/createAbTest'
import { NEXT_PUBLIC_ENABLE_INSTREAM_AD } from '~/lib/env'

export const { getVariant, middleware } = createAbTest({
  getEnabled() {
    return NEXT_PUBLIC_ENABLE_INSTREAM_AD === 'true'
  },
  cookieName: 'instreamAd',
  variantMap: {
    on: 0.5,
    off: 0.5,
  },
  cookieOptions: {
    expires: new Date('2025-08-06T23:59:59+09:00'),
  },
})
